module.exports = __webpack_public_path__ + "img/dsk-logo.cec8f4eb.png";